import * as React from 'react';
import { NaviContext } from './NaviContext';
export function useNavigation() {
  return React.useContext(NaviContext).navigation;
}
export function NaviConsumer(_a) {
  var _children = _a.children;
  return React.createElement(NaviContext.Consumer, {
    children: function children(_a) {
      var navigation = _a.navigation;
      return _children(navigation);
    }
  });
}